var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _g2, _path21, _g3, _path22, _g4, _path23, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 10.3431 15.3431 9 17 9H30C31.6569 9 33 10.3431 33 12V34C33 35.6569 31.6569 37 30 37H17C15.3431 37 14 35.6569 14 34V12Z",
    fill: "white",
    stroke: "#298EB9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 42V42.5C14 44.7091 15.7909 46.5 18 46.5H25.5",
    stroke: "#298EB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7422 13.5V13C51.7422 10.7909 49.9513 9 47.7422 9H40.2422",
    stroke: "#298EB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6211 48.5L25.7424 46.3787L23.6211 44.2574",
    stroke: "#298EB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1213 7L40 9.12132L42.1213 11.2426",
    stroke: "#298EB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14H23.5C23.2239 14 23 14.2239 23 14.5C23 14.7761 23.2239 15 23.5 15H28.5C28.7761 15 29 14.7761 29 14.5C29 14.2239 28.7761 14 28.5 14Z",
    fill: "#298EB9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24H23.5C23.2239 24 23 24.2239 23 24.5C23 24.7761 23.2239 25 23.5 25H28.5C28.7761 25 29 24.7761 29 24.5C29 24.2239 28.7761 24 28.5 24Z",
    fill: "#298EB9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 16H23.5C23.2239 16 23 16.2239 23 16.5C23 16.7761 23.2239 17 23.5 17H26.5C26.7761 17 27 16.7761 27 16.5C27 16.2239 26.7761 16 26.5 16Z",
    fill: "#298EB9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26H23.5C23.2239 26 23 26.2239 23 26.5C23 26.7761 23.2239 27 23.5 27H26.5C26.7761 27 27 26.7761 27 26.5C27 26.2239 26.7761 26 26.5 26Z",
    fill: "#298EB9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15L19.5 16.5L21.5 14",
    stroke: "#99CC99",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25L19.5 26.5L21.5 24",
    stroke: "#99CC99",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19H23.5C23.2239 19 23 19.2239 23 19.5C23 19.7761 23.2239 20 23.5 20H28.5C28.7761 20 29 19.7761 29 19.5C29 19.2239 28.7761 19 28.5 19Z",
    fill: "#298EB9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29H23.5C23.2239 29 23 29.2239 23 29.5C23 29.7761 23.2239 30 23.5 30H28.5C28.7761 30 29 29.7761 29 29.5C29 29.2239 28.7761 29 28.5 29Z",
    fill: "#298EB9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 21H23.5C23.2239 21 23 21.2239 23 21.5C23 21.7761 23.2239 22 23.5 22H26.5C26.7761 22 27 21.7761 27 21.5C27 21.2239 26.7761 21 26.5 21Z",
    fill: "#298EB9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31H23.5C23.2239 31 23 31.2239 23 31.5C23 31.7761 23.2239 32 23.5 32H26.5C26.7761 32 27 31.7761 27 31.5C27 31.2239 26.7761 31 26.5 31Z",
    fill: "#298EB9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20L19.5 21.5L21.5 19",
    stroke: "#99CC99",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30L19.5 31.5L21.5 29",
    stroke: "#99CC99",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 40L61 42.5L65.5 36.5",
    stroke: "#99CC99",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33V21C67 18.7909 65.2091 17 63 17H40.5C38.2909 17 36.5 18.7909 36.5 21V43C36.5 45.2091 38.2909 47 40.5 47H53",
    stroke: "#298EB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 21,
    width: 6,
    height: 6
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46 21H42C41.4477 21 41 21.4477 41 22V26C41 26.5523 41.4477 27 42 27H46C46.5523 27 47 26.5523 47 26V22C47 21.4477 46.5523 21 46 21Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 21H42C41.4477 21 41 21.4477 41 22V26C41 26.5523 41.4477 27 42 27H46C46.5523 27 47 26.5523 47 26V22C47 21.4477 46.5523 21 46 21Z",
    fill: "white",
    stroke: "#298EB9",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_51_639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 29,
    width: 6,
    height: 6
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46 29H42C41.4477 29 41 29.4477 41 30V34C41 34.5523 41.4477 35 42 35H46C46.5523 35 47 34.5523 47 34V30C47 29.4477 46.5523 29 46 29Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_51_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 29H42C41.4477 29 41 29.4477 41 30V34C41 34.5523 41.4477 35 42 35H46C46.5523 35 47 34.5523 47 34V30C47 29.4477 46.5523 29 46 29Z",
    fill: "white",
    stroke: "#298EB9",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_51_639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 37,
    width: 6,
    height: 6
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37H42C41.4477 37 41 37.4477 41 38V42C41 42.5523 41.4477 43 42 43H46C46.5523 43 47 42.5523 47 42V38C47 37.4477 46.5523 37 46 37Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_51_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 37H42C41.4477 37 41 37.4477 41 38V42C41 42.5523 41.4477 43 42 43H46C46.5523 43 47 42.5523 47 42V38C47 37.4477 46.5523 37 46 37Z",
    fill: "white",
    stroke: "#298EB9",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_51_639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 21,
    width: 14,
    height: 6
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21H50C49.4477 21 49 21.4477 49 22V26C49 26.5523 49.4477 27 50 27H62C62.5523 27 63 26.5523 63 26V22C63 21.4477 62.5523 21 62 21Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_51_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 21H50C49.4477 21 49 21.4477 49 22V26C49 26.5523 49.4477 27 50 27H62C62.5523 27 63 26.5523 63 26V22C63 21.4477 62.5523 21 62 21Z",
    fill: "white",
    stroke: "#298EB9",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_51_639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 29,
    width: 14,
    height: 6
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62 29H50C49.4477 29 49 29.4477 49 30V34C49 34.5523 49.4477 35 50 35H62C62.5523 35 63 34.5523 63 34V30C63 29.4477 62.5523 29 62 29Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_51_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 29H50C49.4477 29 49 29.4477 49 30V34C49 34.5523 49.4477 35 50 35H62C62.5523 35 63 34.5523 63 34V30C63 29.4477 62.5523 29 62 29Z",
    fill: "white",
    stroke: "#298EB9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 34C57.134 34 54 37.134 54 41C54 44.866 57.134 48 61 48C64.866 48 68 44.866 68 41C68 39.7758 67.6858 38.6251 67.1336 37.624L65.7564 39.454C65.9145 39.9409 66 40.4604 66 41C66 43.7614 63.7614 46 61 46C58.2386 46 56 43.7614 56 41C56 38.2386 58.2386 36 61 36C61.7217 36 62.4077 36.1529 63.0274 36.4281L64.2526 34.8C63.2808 34.2891 62.1742 34 61 34Z",
    fill: "#298EB9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageIcon1);
export default __webpack_public_path__ + "static/media/manageIcon1.7fc1bfca8813238fd0de0ebe05135573.svg";
export { ForwardRef as ReactComponent };